document.querySelector('[data-id="element-261"]')?.addEventListener('click', function () {
  document.getElementById('atc_pdp_fold')?.click();
});

document.addEventListener('DOMContentLoaded', function () {
    // Script 1: Swiper Variant Change
    const variantSelectors = document.querySelectorAll('.single-option-selector');

    variantSelectors.forEach((selector) => {
      selector.addEventListener('change', function () {
        const selectedVariantImageId = this.getAttribute('data-variant-image-id');
        scrollToVariantImage(selectedVariantImageId);
      });
    });

    function scrollToVariantImage(imageId) {
      const swiperContainer = document.querySelector('.newleanlite-product-swiper');
      if (!swiperContainer || !swiperContainer.swiper) {
        return;
      }

      const swiperInstance = swiperContainer.swiper;
      const slides = swiperInstance.slides;
      let slideIndex = -1;

      slides.forEach((slide, index) => {
        const mediaId = slide.getAttribute('data-media-id');
        if (mediaId === imageId) {
          slideIndex = index;
        }
      });

      if (slideIndex !== -1) {
        swiperInstance.slideTo(slideIndex);
      } else {
        console.log('Image ID not found in any slide.');
      }
    }

    // Script 2: Update Active Variant
    const variantInputs = document.querySelectorAll('.product-form__input');
    const productID = document.querySelector('.product-form__input').getAttribute('data-product-id');
    const variantSelect = document.querySelector(`#ProductSelect-${productID}`);

    function updateActiveVariant(input) {
      // Remove the active class from all options
      variantInputs.forEach((input) => {
        input.closest('.variant-option').classList.remove('variant-option--active');
      });

      // Add the active class to the selected variant and update the select element
      const parentOption = input.closest('.variant-option');
      if (input.checked) {
      //   const price = parentOption.querySelector('.variant-asp').innerText;
        
      //   document.querySelector('[data-id="element-236"]').textContent = price;
        parentOption.classList.add('variant-option--active');
        variantSelect.value = input.getAttribute('data-variant-id');

      //   setTimeout(() => {
      //     const supply = document.querySelector('.supply');
      //     const target = document.querySelector('[data-id="element-233"]');

      //     if (supply && target) {
      //       target.textContent = supply.innerText;
      //     }
      //   }, 100);
      }
    }

    // Event listener for changes
    variantInputs.forEach((input) => {
      input.addEventListener('change', function () {
        updateActiveVariant(input);
      });
    });

    // Set the default active variant on initial load
    const checkedInput = document.querySelector('.product-form__input:checked');
    if (checkedInput) {
      updateActiveVariant(checkedInput);
    }
});


document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll('[data-id="element-223"]');
  buttons.forEach(button => {
    button.addEventListener("click", function () {
      const content = this.parentElement.querySelector('[data-id="element-227"]');
      const icon = this.querySelector('svg');
      const isOpen = this.getAttribute("aria-expanded") === "true";

      buttons.forEach(btn => {
        const c = btn.parentElement.querySelector('[data-id="element-227"]');
        const i = btn.querySelector('svg');
        btn.setAttribute("aria-expanded", "false");
        btn.classList.remove('bg-plum','text-cream','shadow-md');
        btn.classList.add('bg-white', 'text-plum');
        if(i){
          i.classList.remove('rotate-180','text-rose');
          i.classList.add('text-plum/40');
        }
        c.style.height = "0px";
        c.style.opacity = "0";
      });

      if (!isOpen) {
        this.setAttribute("aria-expanded", "true");
        this.classList.remove('bg-white', 'text-plum');
        this.classList.add('bg-plum','text-cream','shadow-md');

        if(icon){
          icon.classList.remove('text-plum/40');
          icon.classList.add('rotate-180','text-rose');
        }

        content.style.height = content.scrollHeight + "px";
        content.style.opacity = "1";
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll('[data-id="element-159"]');
  buttons.forEach(button => {
    button.addEventListener("click", function () {
      const parent = this.parentElement;
      const content = parent.querySelector('[data-id="element-163"]');
      const icon = this.querySelector('svg');
      const isOpen = parent.classList.contains('active');

      // close all
      buttons.forEach(btn => {
        const p = btn.parentElement;
        const c = p.querySelector('[data-id="element-163"]');
        const i = btn.querySelector('svg');

        p.classList.remove('active');

        c.style.height = "0px";
        c.style.opacity = "0";

        if(i) i.style.transform = "rotate(0deg)";
      });

      // open clicked
      if (!isOpen) {

        parent.classList.add('active');

        content.style.height = content.scrollHeight + "px";
        content.style.opacity = "1";

        if(icon) icon.style.transform = "rotate(180deg)";
      }
    });
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll('[data-id="element-86"]');
  buttons.forEach(button => {
    button.addEventListener("click", function () {
      const item = this.closest('[data-id="element-84"]');
      const content = item.querySelector('[data-id="element-88"]');
      const icon = this.querySelector('svg');
      const isOpen = this.getAttribute("aria-expanded") === "true";

      // Close all
      buttons.forEach(btn => {
        const parent = btn.closest('[data-id="element-84"]');
        const c = parent.querySelector('[data-id="element-88"]');
        const i = btn.querySelector('svg');
        btn.setAttribute("aria-expanded", "false");
        btn.setAttribute("data-state", "closed");
        parent.setAttribute("data-state", "closed");
        c.hidden = true;
        c.style.height = "0px";
        if(i) i.style.transform = "rotate(0deg)";
      });

      // Open clicked
      if (!isOpen) {

        this.setAttribute("aria-expanded", "true");
        this.setAttribute("data-state", "open");
        item.setAttribute("data-state", "open");
        content.hidden = false;
        content.style.height = content.scrollHeight + "px";
        if(icon) icon.style.transform = "rotate(180deg)";
      }
    });
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   const stickyBar = document.querySelector('[data-id="element-229"]');

//   window.addEventListener("scroll", function () {
//     if (window.scrollY > 500) {  
//       stickyBar.style.transform = "translateY(0)";
//     } else {
//       stickyBar.style.transform = "translateY(100px)";
//     }
//   });
// });